import {Page, Skeleton, Topbar} from '@blesk-frontend/ui';

export const GuideSkeleton = () => {
  return (
    <Page>
      <Topbar>
        <Skeleton className="size-10" />
        <Skeleton className="h-6 w-32" />
      </Topbar>

      <div className="prose prose-sm md:prose-base mx-auto max-w-screen-md outline-0">
        <div className="mb-4 flex items-center gap-4 md:mb-6">
          <Skeleton className="h-6 w-32" />
        </div>

        <Skeleton className="mb-4 h-10 w-80" />
        <Skeleton className="h-4 w-24" />
      </div>
    </Page>
  );
};
